// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__s4fH0","parceiros":"styles_parceiros__C5Ny9"};